import React, { useState } from "react";
import { createContactForm } from "../../services/messagingService";
import "../../css/contact-form.css";
import { toast } from "react-toastify";

const ContactFormOverlay = ({ isOpen, onClose, id, role, links, isMobile }) => {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await createContactForm({
                target_profile_id: id, // ✅ PROFILE ID
                context: role,                   // ✅ explicit context
                ...formData,
            });

            toast.success("Message sent successfully");

            onClose();
        } catch (err) {
            console.error("Failed to send contact form", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="contact-overlay-backdrop">
            <div className="contact-overlay">
                <button className="close-btn" onClick={onClose}>
                    <i className="fa-solid fa-xmark" />
                </button>

                <h3>Contact Form</h3>
                

                <form onSubmit={handleSubmit}>

                    
                    <input
                        name="name"
                        placeholder="Your name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />

                    <input
                        name="phone"
                        placeholder="Phone number"
                        value={formData.phone}
                        onChange={handleChange}
                    />

                    <input
                        name="email"
                        type="email"
                        placeholder="Email address"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />

                    <textarea
                        name="message"
                        placeholder="What Service is needed?"
                        rows={4}
                        value={formData.message}
                        onChange={handleChange}
                        required
                    />

                    <button type="submit" disabled={loading}>
                        <i className="fa-solid fa-paper-plane" /> {loading ? "Sending..." : "Send Contact Form"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ContactFormOverlay;
